"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledButton = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _templateObject23() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    /* apply the default styles */\n    ", "\n\n    /* apply different variation styles */\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    /* apply differently themed flavours */\n    ", "\n    ", "\n    ", "\n    ", "\n\n    /* size styles */\n    ", "\n    ", "\n    ", "\n    ", "\n\n    /* if the button is an fullwidth */\n    ", "\n\n     /* Padding styles */\n     ", "\n\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 0px;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n    padding: ", " ", ";\n    line-height: 24px;\n\n    /* Overwrite styling if icon */\n    ", ";\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", " ", ";\n  line-height: 20px;\n\n  /* Overwrite styling if icon */\n  ", ";\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", " ", ";\n  line-height: 16px;\n\n  /* Overwrite styling if icon */\n  ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n  line-height: 16px;\n\n  /* Overwrite styling if icon */\n  ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  line-height: 1.4rem;\n  font-weight: 600;\n  color: ", ";\n  cursor: pointer;\n  padding: ", " ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  outline: none;\n  border: 1px solid ", ";\n  transition: all 0.2s;\n  white-space: nowrap;\n\n  ", ";\n\n  :not([disabled]):hover {\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  opacity: 0.4;\n  transition: 0;\n  user-select: none;\n  cursor: default;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  box-shadow: 0 4px 8px\n    rgba(", ", 0.3);\n  transform: translateY(0);\n\n  :not([disabled]):hover {\n    box-shadow: 0 12px 20px\n      rgba(", ", 0.3);\n    transform: translateY(-2px);\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  border-radius: 24px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  border: 1px solid rgba(", ", 0.2);\n  background-color: rgba(", ", 0.2);\n\n  :not([disabled]):hover {\n    background-color: rgba(\n      ", ",\n      0.2\n    );\n    border: 1px solid ", ";\n  }\n\n  :not([disabled]):active {\n    background-color: rgba(\n      ", ",\n      0.3\n    );\n    color: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  border: 1px solid ", ";\n  background-color: transparent;\n\n  :not([disabled]):hover {\n    border: 1px solid ", ";\n    background-color: rgba(\n      ", ",\n      0.2\n    );\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  border: 0px;\n  background-color: transparent;\n\n  :not([disabled]):hover {\n    background-color: rgba(\n      ", ",\n      0.2\n    );\n    border: rgba(", ", 0.2);\n  }\n\n  :not([disabled]):active {\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            border: 1px solid rgba(", ", 0.2);\n            color: ", ";\n            background-color: rgba(", ", 0.2);\n\n            &:not([disabled]):hover {\n              background-color: rgba(", ", 0.3);\n              border: 1px solid ", ";\n            }\n\n            &:not([disabled]):active {\n              background-color: rgba(", ", 0.3);\n              color: ", ";\n            }\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            border: 1px solid ", ";\n            color: ", ";\n            background-color: transparent;\n\n            &:not([disabled]):hover {\n              border: 1px solid ", ";\n              background-color: rgba(", ", 0.2);\n            }\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            border: 0px;\n            color: ", ";\n            background-color: transparent;\n\n            &:not([disabled]):hover {\n              background-color: rgba(", ", 0.2);\n              border: rgba(", ", 0.2);\n            }\n\n            &:not([disabled]):active {\n              background-color: ", ";\n              color: ", ";\n            }\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n\n    :not([disabled]):hover {\n        background-color: ", ";\n        border: 1px solid ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var applyThemeStyles = function applyThemeStyles(primary, secondary) {
  return (0, _styledComponents.css)(_templateObject(), primary, primary, secondary, function (props) {
    return props.theme.utils.lightenDarken(primary, 20);
  }, primary, function (props) {
    return props.flat ? (0, _styledComponents.css)(_templateObject2(), primary, props.theme.utils.hexToRGB(primary), props.theme.utils.hexToRGB(primary), primary, secondary) : '';
  }, function (props) {
    return props.ghost ? (0, _styledComponents.css)(_templateObject3(), primary, primary, primary, props.theme.utils.hexToRGB(primary)) : '';
  }, function (props) {
    return props.translucent ? (0, _styledComponents.css)(_templateObject4(), props.theme.utils.hexToRGB(primary), primary, props.theme.utils.hexToRGB(primary), props.theme.utils.hexToRGB(primary), primary, props.theme.utils.hexToRGB(primary), primary) : '';
  });
};

var flat = (0, _styledComponents.css)(_templateObject5(), function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.liva[500]);
}, function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.liva[500]);
}, function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.theme.colors.lychee[100];
});
var ghost = (0, _styledComponents.css)(_templateObject6(), function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.liva[500]);
});
var translucent = (0, _styledComponents.css)(_templateObject7(), function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.liva[500]);
}, function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.liva[500]);
}, function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.liva[500]);
}, function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.liva[500]);
}, function (props) {
  return props.theme.colors.liva[500];
});
var rounded = (0, _styledComponents.css)(_templateObject8());
var raised = (0, _styledComponents.css)(_templateObject9(), function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.blackberry[600]);
}, function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.blackberry[600]);
});
var disabledStyles = (0, _styledComponents.css)(_templateObject10());
var iconBase = (0, _styledComponents.css)(_templateObject11(), function (props) {
  return props.theme.spacing[2];
});
var defaults = (0, _styledComponents.css)(_templateObject12(), function (props) {
  return props.theme.fonts.subtitle2;
}, function (props) {
  return props.theme.colors.lychee[100];
}, function (props) {
  return props.theme.spacing[2];
}, function (props) {
  return props.theme.spacing[4];
}, function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.theme.colors.liva[500];
}, function (props) {
  return props.icon ? iconBase : '';
}, function (props) {
  return props.theme.utils.lightenDarken(props.theme.colors.liva[500], 20);
}, function (props) {
  return props.theme.colors.liva[500];
});
var iconXsmall = (0, _styledComponents.css)(_templateObject13(), function (props) {
  return props.theme.spacing[1];
});
var xsmall = (0, _styledComponents.css)(_templateObject14(), function (props) {
  return props.theme.spacing[1];
}, function (props) {
  return props.icon ? iconXsmall : '';
});
var iconSmall = (0, _styledComponents.css)(_templateObject15(), function (props) {
  return props.theme.spacing[2];
});
var small = (0, _styledComponents.css)(_templateObject16(), function (props) {
  return props.theme.spacing[2];
}, function (props) {
  return props.theme.spacing[3];
}, function (props) {
  return props.icon ? iconSmall : '';
});
var iconMedium = (0, _styledComponents.css)(_templateObject17(), function (props) {
  return props.theme.spacing[3];
});
var medium = (0, _styledComponents.css)(_templateObject18(), function (props) {
  return props.theme.spacing[2];
}, function (props) {
  return props.theme.spacing[3];
}, function (props) {
  return props.icon ? iconMedium : '';
});
var iconLarge = (0, _styledComponents.css)(_templateObject19(), function (props) {
  return props.theme.spacing[4];
});
var large = (0, _styledComponents.css)(_templateObject20(), function (props) {
  return props.theme.fonts.subtitle1;
}, function (props) {
  return props.theme.spacing[2];
}, function (props) {
  return props.theme.spacing[4];
}, function (props) {
  return props.icon ? iconLarge : '';
});
var fullWidth = (0, _styledComponents.css)(_templateObject21());
var disablePadding = (0, _styledComponents.css)(_templateObject22());

var StyledButton = _styledComponents["default"].button(_templateObject23(), defaults, function (props) {
  return props.disabled ? disabledStyles : '';
}, function (props) {
  return props.flat ? flat : '';
}, function (props) {
  return props.ghost ? ghost : '';
}, function (props) {
  return props.rounded ? rounded : '';
}, function (props) {
  return props.raised ? raised : '';
}, function (props) {
  return props.translucent ? translucent : '';
}, function (props) {
  return props.info ? applyThemeStyles(props.theme.colors.plum[500], props.theme.colors.lychee[100]) : '';
}, function (props) {
  return props.warning ? applyThemeStyles(props.theme.colors.strawberry[400], props.theme.colors.lychee[100]) : '';
}, function (props) {
  return props.licorice ? applyThemeStyles(props.theme.colors.blackberry[400], props.theme.colors.lychee[100]) : '';
}, function (props) {
  return props.vanilla ? applyThemeStyles(props.theme.colors.lychee[100], props.theme.colors.blackberry[400]) : '';
}, function (props) {
  return props.size === 'xsmall' ? xsmall : '';
}, function (props) {
  return props.size === 'small' ? small : '';
}, function (props) {
  return props.size === 'medium' ? medium : '';
}, function (props) {
  return props.size === 'large' ? large : '';
}, function (props) {
  return props.fullWidth ? fullWidth : '';
}, function (props) {
  return props.disablePadding ? disablePadding : '';
});

exports.StyledButton = StyledButton;
var _default = {
  StyledButton: StyledButton
};
exports["default"] = _default;